(function () {
  if (customElements.get("slide-showcase-wrapper")) {
    return;
  }

  const _preventDefault = (e) => {
    e.preventDefault();
  };

  class SlideShowcaseWrapper extends HTMLElement {
    constructor() {
      super();
      this.prevButton = this.querySelector("a.prev");
      this.nextButton = this.querySelector("a.next");
      this.itemsWrapper = this.querySelector("ul.collections");

      this.childATag = undefined;

      this.activeIndex = 1;
      this.itemOffset = 10;
      this.isTransitionrun = false;
      this.isDraging = false;

      this.prevButton.addEventListener("click", this.onPrev.bind(this));
      this.nextButton.addEventListener("click", this.onNext.bind(this));
      this.itemsWrapper.addEventListener(
        "transitionend",
        this.onTransitionEnd.bind(this)
      );

      window.addEventListener("resize", () => {
        this.setWrapperTransition();
      });

      this.itemsWrapper.onmousedown = (e) => {
        e.preventDefault();
        const onMouseMove = (moveEvent) => {
          moveEvent.preventDefault();
          this.onDrag(moveEvent.pageX, moveEvent);
        };
        this.onDragStart(e.pageX);

        document.addEventListener("mousemove", onMouseMove);
        document.onmouseup = (endEvent) => {
          endEvent.preventDefault();
          this.onDragEnd();
          document.removeEventListener("mousemove", onMouseMove);
        };
      };

      this.itemsWrapper.addEventListener("touchstart", (e) => {
        this.onDragStart(e.touches[0].clientX);
      });
      this.itemsWrapper.addEventListener("touchmove", (e) => {
        if (this.isDraging) {
          e.preventDefault();
        }
        this.onDrag(e.touches[0].clientX, e);
      });
      this.itemsWrapper.addEventListener("touchend", (e) => {
        this.onDragEnd();
      });

      this.initWrapper();
    }

    initWrapper() {
      const cloneNodeBefore = this.itemsWrapper.cloneNode(true);
      const cloneNodeAfter = this.itemsWrapper.cloneNode(true);
      const itemCount = cloneNodeBefore.childNodes.length;
      let beforeNodes = [],
        afterNodes = [];
      this.itemOffset = itemCount;
      Array.prototype.map.call(cloneNodeBefore.childNodes, (el, i) => {
        el.classList.add("clone");
        beforeNodes.unshift(el);
      });
      Array.prototype.map.call(cloneNodeAfter.childNodes, (el, i) => {
        el.classList.add("clone");
        afterNodes.push(el);
      });
      beforeNodes.map((el) => {
        this.itemsWrapper.insertBefore(el, this.itemsWrapper.children[0]);
      });
      afterNodes.map((el) => {
        this.itemsWrapper.appendChild(el);
      });
      this.setWrapperTransition();
    }

    setWrapperTransition() {
      const itemWidth = this.itemsWrapper.children[0].clientWidth;

      this.showCount = 5;
      const showWidth = itemWidth * this.showCount;
      const clientWidth =
        document.documentElement.clientWidth === 0
          ? document.body.clientWidth
          : document.documentElement.clientWidth;

      this.rawOffset = (showWidth - clientWidth) / 2;
      const itemRawOffset = this.itemOffset - Math.floor(this.showCount / 2);
      this.itemsWrapper.style.transform = `translate3d(-${
        this.rawOffset + itemWidth * (itemRawOffset + this.activeIndex - 1)
      }px, 0px, 0px)`;
    }

    onPrev(e) {
      e.preventDefault();
      if (this.isTransitionrun) {
        return;
      }
      this.activeIndex--;
      this.onTransitionStart();
    }

    onNext(e) {
      e.preventDefault();
      if (this.isTransitionrun) {
        return;
      }
      this.activeIndex++;
      this.onTransitionStart();
    }

    onTransitionStart() {
      this.isTransitionrun = true;
      this.itemsWrapper.style.transition = "transform 0.3s";
      this.setWrapperTransition();
    }

    onTransitionEnd() {
      this.itemsWrapper.style.transition = "";
      const activeItem =
        this.itemsWrapper.childNodes[this.activeIndex + this.itemOffset - 1];
      const isClone = activeItem.classList.contains("clone");
      if (isClone) {
        this.activeIndex = Number(activeItem.getAttribute("data-index"));
        this.setWrapperTransition();
      }
      this.removePreventDefault();
      this.isTransitionrun = false;
    }

    onDragStart(x) {
      this.dragStartX = x;
      this.originTranslateX = parseFloat(
        this.itemsWrapper.style.transform.split("(")[1].split(",")[0]
      );
      this.itemsWrapper.style.cursor = "grab";
    }

    onDrag(x, event) {
      this.isDraging = true;
      if (event.target.classList.contains("full-unstyled-link")) {
        this.childATag = event.target;
        this.childATag.addEventListener("click", _preventDefault);
      }
      this.itemsWrapper.style.transform = `translate3d(${
        this.originTranslateX + (x - this.dragStartX)
      }px, 0px, 0px)`;
    }

    onDragEnd() {
      if (!this.isDraging) {
        return;
      }
      const transitionX = Math.abs(
        parseFloat(
          this.itemsWrapper.style.transform.split("(")[1].split(",")[0]
        )
      );
      const itemWidth = this.itemsWrapper.children[0].clientWidth;
      const dragDistance =
        parseFloat(
          this.itemsWrapper.style.transform.split("(")[1].split(",")[0]
        ) - this.originTranslateX;
      if (
        Math.abs(dragDistance) < itemWidth * 0.6 &&
        Math.abs(dragDistance) > itemWidth * 0.15
      ) {
        this.activeIndex = this.activeIndex + (dragDistance > 0 ? -1 : 1);
      } else {
        let activeIndex = Number(
          (
            (transitionX - this.rawOffset) / itemWidth -
            this.itemOffset +
            parseInt(this.showCount / 2)
          ).toFixed()
        );
        this.itemsWrapper.style.cursor = "";
        this.activeIndex = activeIndex + 1;
      }
      setTimeout(() => {
        this.removePreventDefault();
      }, 350);
      this.onTransitionStart();
      this.isDraging = false;
    }

    removePreventDefault() {
      if (this.childATag) {
        this.childATag.removeEventListener("click", _preventDefault);
        this.childATag = undefined;
      }
    }
  }

  customElements.define("slide-showcase-wrapper", SlideShowcaseWrapper);
})();
